module.exports = __webpack_public_path__ + "img/time-off-day.fc1886bb.png";